import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';

import rootReducer from './rootReducer';

const loggerMiddleware = createLogger();

let middlewares = [
  ...getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: ['dsps/fetchDsps/fulfilled', 'deliveryTypes/fetchDeliveryTypes/fulfilled'],
    },
  }),
];

if (process.env.NODE_ENV === 'development') {
  middlewares = [...middlewares, loggerMiddleware];
}

const store = configureStore({
  reducer: rootReducer,
  middleware: middlewares,
  devTools: process.env.NODE_ENV !== 'production',
});

export const setupStore = preloadedState => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};

export default store;
